import { Injectable, OnDestroy } from '@angular/core';
import { HttpClient } from "@angular/common/http";
import { BackendListModel } from "../../../models/common/list.model";
import { Subject, takeUntil, debounceTime, distinctUntilChanged, switchMap, of } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class MatAutoSearchService {

  private destroy$ = new Subject<void>();

  constructor(private http: HttpClient) { }

  retrieveObject(url) {
    return this.http.get(url)
  }

  listObjects(url) {
    this.destroy$.next();
    this.destroy$.complete();
    this.destroy$ = new Subject<void>();

    return this.http.get<BackendListModel<any>>(url).pipe(
      takeUntil(this.destroy$),
      // debounceTime(300),
      distinctUntilChanged(),
      switchMap(response => {
        return of(response);
      })
    );
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
